/**
 * Geofence API service for Aegix One.
 *
 * Fetches user geofences from `/api/v2/site-geofence/mine/`.
 */

import { client, unwrap } from '../lib/http-client';
import type { components } from '@tiaki/http-client/types';

export type SiteGeoFence = components['schemas']['SiteGeoFence'];

/**
 * Fetch the current user's geofences.
 */
export async function getSiteGeofences(): Promise<SiteGeoFence[]> {
  const result = await client.GET('/api/v2/site-geofence/mine/', {});
  return unwrap(result);
}
